import AdminDetail from "../components/AdminDetail";
import useAdminDetail from "../hooks/useAdminDetail";

function AdminDetailPage(props) {
    const UseAdminDetailProps = useAdminDetail(props);
    return <AdminDetail {...UseAdminDetailProps} />
}

export default AdminDetailPage;